export default __webpack_public_path__ + "static/media/full-bundle-accuchek-gray@2x.945352f7.webp";